<div [class]="cssClass">
  <div class="inner-label">
    <mat-icon class="alert-icon">
      <img [src]="data.icon" alt="Alert Icon" />
    </mat-icon>
    <h6>
      <!-- {{ data?.title }} -->
      <p>{{ data?.message }}</p>
    </h6>
  </div>
  <button mat-icon-button color="default" matSnackBarActions>
    <mat-icon (click)="snackBarRef.dismissWithAction()">
      <svg
        width="10"
        height="10"
        viewBox="0 0 10 10"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.11875 9.8627L5.14375 5.88144L1.16875 9.8627L0.28125 8.97519L4.2625 5.0002L0.28125 1.0252L1.16875 0.137695L5.14375 4.11895L9.11875 0.143945L10 1.0252L6.025 5.0002L10 8.97519L9.11875 9.8627Z"
          fill="currentColor"
        />
      </svg>
    </mat-icon>
  </button>
</div>
